import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "permission-denied-page" }

import { PermissionDeniedPropsVariant } from '@/rex-components/PermissionDenied/PermissionDenied.type';
import PermissionDenied from '@/rex-components/PermissionDenied/PermissionDenied.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PermissionDenied, {
      variant: _unref(PermissionDeniedPropsVariant).TRANSLUCENT
    }, null, 8, ["variant"])
  ]))
}
}

})